import React from 'react';
import PropTypes from 'prop-types';
import { CONFIG } from 'ui-utilities';
import MapboxAutocomplete from 'react-mapbox-autocomplete';

export default class Location extends React.Component {
  _suggestionSelect(result, lat, lng, text) {
    this.props._plan.setBusinessLocation({
      coords: {
        latitude: parseFloat(lat),
        longitude: parseFloat(lng)
      },
      place_name: result
    });
  }

  render() {
    let placeHolder = this.props.placeholder;
    const { customer } = this.props;

    if (customer.get('location').get('place_name') !== '') {
      placeHolder = customer.get('location').get('place_name') ? 'Near: ' + customer.get('location').get('place_name') : 'Location';
    }

    return <MapboxAutocomplete
      publicKey={CONFIG.MAPBOX_KEY}
      onSuggestionSelect={this._suggestionSelect.bind(this)}
      country='us'
      resetSearch={false}
      placeholder={placeHolder} />;
  }
}

Location.propTypes = {
  _plan: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/Search/Location.js